import { Injectable } from '@angular/core';
import { EmailsService } from '@app-services/emails/emails.service';
import { EmailsScrollService } from '@app-services/emails/emails-scroll.service';
import { FileClient } from '@app-services/api/clients/file.client';
import { MatchError } from '@app-services/errors/error-matcher';
import { SnackbarService } from '@app-services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { EmailClient } from '@app-services/api/clients/email-client';
import { TempFileClient } from '@app-services/api/clients/temp-file.client';
import { UserWorkspaceService } from '@app-services/user-workspace-service';
import { EmailsPageStateService } from '@app-services/emails/emails-page-state.service';

@Injectable({ providedIn: 'root' })
export class EmailActionsContextService {
  constructor(
    public readonly emailsService: EmailsService,
    public readonly emailsScrollService: EmailsScrollService,
    public readonly emailClient: EmailClient,
    public readonly fileClient: FileClient,
    public readonly tempFileClient: TempFileClient,
    public readonly matchError: MatchError,
    public readonly snackbarHelper: SnackbarService,
    public readonly translate: TranslateService,
    public readonly userWorkspaceService: UserWorkspaceService,
    public readonly emailsPageStateService: EmailsPageStateService
  ) {}
}
